<template>
  <div class="bg-white min-h-screen flex flex-col">
    <RenderTemplateHeader />

    <main class="flex-1">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~/modules/template/composables/useTemplateDataComposable'

await useTemplateDataComposable({
  template: 'funnel',
})
</script>
